import Dialog, { IAction } from '../../../ui/dialog/Dialog';
import React from 'react';
import { ButtonColor } from '../../../ui/button/Button';

interface IActionDialog {
  actionList: IAction[];
  onCloseAction?: VoidFunction;
}

// tslint:disable-next-line:variable-name
export const ActionDialog: React.FC<IActionDialog> = ({ onCloseAction, actionList, children }) => {
  //adding manually action color since dialog component need to a color prop to resolve color from theme
  const actions = actionList.map((action) => ({ ...action, color: ButtonColor.primaryLightBlue }));
  return (
    <Dialog actionList={actions} isCloseAppModal={!!onCloseAction} onAction={onCloseAction}>
      {children}
    </Dialog>
  );
};
